const phase4 = {
  number: 4,
  title: "Taper & Race",
  weeks: "Weeks 17–19",
  dates: "Jun 8 – Jun 27",
  color: "#C0392B",
  light: "#FDF0EF",
  accent: "#922B21",
  running: "Volume drops 30% — stay sharp, not tired",
  hrTarget: "All runs easy Zone 2 ({Z2})",
  watchAlert: "Race day: Jun 27 — Futóest 10.55 km",
  weekData: [
    {
      week: 17,
      label: "Week 17",
      focus:
        "Volume drops sharply. Legs will feel restless — store that energy. Do not add extra runs.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 4 km — Zone 2",
          note: "Lighter KB effort — 2 sets only. Short and easy run.",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Easy 3 km — Zone 2",
          note: "Very short run. Just keep legs moving.",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "run",
          run: "Easy 4 km — Zone 2",
          note: "Run only — no strength. Save the muscles.",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        { day: "Sun", type: "rest", note: "Full rest" },
      ],
    },
    {
      week: 18,
      label: "Week 18",
      focus: "Very short, very easy. Sleep well. Eat well. Body is storing energy.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 3 km — Zone 2",
          note: "Minimal KB — 2 sets only, go through the motions",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Easy 3 km — Zone 2",
          note: "Last proper strength session before the race",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "run",
          run: "Easy 3 km — Zone 2",
          note: "Short shakeout. Should feel effortlessly easy.",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        { day: "Sun", type: "rest", note: "Full rest" },
      ],
    },
    {
      week: 19,
      label: "Week 19",
      focus: "Race week. No KB. Short runs only. June 27 — RACE DAY.",
      isRaceWeek: true,
      days: [
        {
          day: "Mon",
          type: "run",
          run: "Easy 2 km — very light shakeout",
          note: "Just a gentle jog. Keep legs loose.",
        },
        { day: "Tue", type: "rest", note: "Full rest. Walk only." },
        {
          day: "Wed",
          type: "run",
          run: "Easy 2 km — very light shakeout",
          note: "Last midweek run. Nothing more.",
        },
        { day: "Thu", type: "rest", note: "Full rest. Carb-load begins — pasta, rice, bread." },
        {
          day: "Fri",
          type: "rest",
          note: "Carb-load day 2. Lay out all gear tonight. Early to bed.",
        },
        {
          day: "Sat",
          type: "rest",
          note: "Full rest. Light meal. Early to bed. Race is tomorrow evening.",
        },
        {
          day: "Sun",
          type: "race",
          run: "RACE — Futóest Quarter Marathon 10.55 km",
          note: "Evening race. Arrive early. Start easy. Finish strong.",
        },
      ],
    },
  ],
  workouts: {
    A: {
      name: "Workout A — Light Activation",
      duration: "~25 min (reduced — 2 sets only)",
      exercises: [
        {
          name: "Glute Bridge",
          sets: "2 × 12",
          cue: "Back to basics. Activate glutes before the run. Bodyweight only — no KB needed.",
          muscles: "Glutes",
        },
        {
          name: "KB Swing",
          sets: "2 × 12",
          cue: "Lighter effort. Hip activation, not fatigue. Stop 3 reps before you feel worked.",
          muscles: "Glutes, cardio",
        },
        {
          name: "Romanian Deadlift",
          sets: "2 × 10",
          cue: "Maintain the movement pattern. Light touch — don't push hard.",
          muscles: "Hamstrings",
        },
        {
          name: "Dead Bug",
          sets: "2 × 8 each",
          cue: "Core activation. Calm and controlled. Just keeping the pattern.",
          muscles: "Core",
        },
        {
          name: "Farmer Carry",
          sets: "2 × 15 steps each",
          cue: "Short and easy. Posture reminder only.",
          muscles: "Core, grip",
        },
      ],
    },
    B: {
      name: "Workout B — Light Maintenance",
      duration: "~25 min (reduced — 2 sets only)",
      exercises: [
        {
          name: "Hip Thrust",
          sets: "2 × 12",
          cue: "Light activation. Keep glutes firing. No KB on hips this phase — bodyweight only.",
          muscles: "Glutes",
        },
        {
          name: "KB Row",
          sets: "2 × 10 each",
          cue: "Maintain upper back posture for race day form.",
          muscles: "Upper back",
        },
        {
          name: "KB Halo",
          sets: "2 × 6 each dir",
          cue: "Shoulder mobility. Loosen everything up.",
          muscles: "Shoulders",
        },
        {
          name: "Push-Up",
          sets: "2 × 8",
          cue: "Easy. Just maintain. Don't fatigue the pushing muscles before race.",
          muscles: "Chest",
        },
        {
          name: "Goblet Squat (shallow)",
          sets: "2 × 8",
          cue: "Very light. Just move the joints. Knee-safe range only.",
          muscles: "Quads, glutes",
        },
      ],
    },
  },
  typeConfig: {
    "strength+run": { bg: "#FDF0EF", border: "#C0392B", label: "KB + Run", dot: "#C0392B" },
    run: { bg: "#FFF8F0", border: "#E67E22", label: "Run Only", dot: "#E67E22" },
    race: { bg: "#FFFDE7", border: "#F9A825", label: "🏁 RACE DAY", dot: "#F9A825" },
    rest: { bg: "#F5F5F5", border: "#CCCCCC", label: "Rest", dot: "#BBBBBB" },
  },
  raceDay: [
    {
      time: "Morning",
      action: "Normal breakfast",
      detail: "Familiar food only — oats, banana, toast. Nothing new.",
    },
    {
      time: "Afternoon",
      action: "Rest & prepare",
      detail: "Light activity only. Double-check kit: shoes, watch, bib number.",
    },
    {
      time: "1.5h before",
      action: "Travel to venue",
      detail: "Arrive early. No rushing on race day.",
    },
    {
      time: "45min before",
      action: "Warmup jog",
      detail: "10 min easy jog + dynamic stretches. Get HR moving.",
    },
    {
      time: "Start",
      action: "Go out EASY",
      detail: "First 2 km should feel almost too easy. You will be tempted to go faster. Don't.",
    },
    {
      time: "km 5",
      action: "Check in with body",
      detail: "Feeling strong? Very slightly increase effort. Tired? Maintain.",
    },
    {
      time: "km 8",
      action: "Push if you have it",
      detail: "Home stretch. Use whatever you have left.",
    },
    {
      time: "Finish",
      action: "Celebrate",
      detail: "You just completed your first race. Take a moment to feel it.",
    },
  ],
};

export default phase4;
